<smata-navbar (logout)="handleUserLogout()"></smata-navbar>
<smata-header-page [title]="pageHeaderStore.title()"></smata-header-page>
<div class="h-100 smata-layout-container">
  <div class="d-flex justify-content-center top-menu-bar layout-body">
    <div class="page-content flex-shrink-1 flex-grow-1 bg-white smata-flex-scroll-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
